// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* purgecss start ignore */\n\n.column_2 {\n  width: 48%;\n  margin: 1em 0.5%;\n}\n\n.column_3 {\n  width: 32%;\n  margin: 1em 0.5%;\n}\n\n@media (max-width: 600px) {\n  .column_2,\n  .column_3 {\n    width: 100%;\n    margin-bottom: 1em;\n  }\n}\n\n/* purgecss end ignore */\n", ""]);
// Exports
module.exports = exports;
